import AOS from 'aos';
import initializeMobileMenu from './menu';
import initializeFancyBox from './fancybox';
import initializeHomeSlider from "./blocks/home-slider";
import initializeBlockIconBoxes from "./blocks/icon-boxes";
import initializeLogotypes from "./blocks/logotypes";
import initializeMovie from "./blocks/movie";
import initializeGalleryGrid from "./blocks/gallery-grid";
import initializeBrands from './blocks/brands';
import initializeAllCollapses from './blocks/collapse';
// import initializeMapOsm from './blocks/map-osm';

class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        initializeAllCollapses();
        AOS.init({
            disable: 'mobile',
            once: false,
            duration: 1000
        });
        initializeBrands();
        initializeFancyBox();
        initializeMobileMenu();
        initializeBlockIconBoxes();
        initializeLogotypes();
        initializeHomeSlider();
        initializeGalleryGrid();
        initializeMovie();
        // initializeMapOsm();
    }
}

function initializeApp() {
    const app = new App();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
